import { Flex, Segmented, Tabs } from 'antd'
import { useState } from 'react'

import Breadcrumb from 'component/breadcrumb/breadcrumb'
import { BREADCRUMBS } from 'constants/breadcrumb'
import { PtoReferralOverviewCards } from 'modules/pto-referral/overview-cards'
import { PartnerReferral } from 'modules/pto-referral/partner/partner-referral'
import { PtoReferralTable } from 'modules/pto-referral/referral-table'
import { PtoReferralUsersTable } from 'modules/pto-referral/users-table'

import './styles.scss'

type ReferralMode = 'normal' | 'partner'

const NormalUsersReferral = () => {
  const tabItems = [
    {
      key: 'ptos',
      label: 'PTOs',
      children: <PtoReferralTable />,
    },
    {
      key: 'users',
      label: 'Users',
      children: <PtoReferralUsersTable />,
    },
  ]

  return (
    <>
      <PtoReferralOverviewCards />

      <Tabs defaultActiveKey="ptos" items={tabItems} destroyInactiveTabPane />
    </>
  )
}

const PtoReferralProgram = () => {
  const breadCrumbItems = [BREADCRUMBS.PTO_REFERRAL]
  const [mode, setMode] = useState<ReferralMode>('normal')

  return (
    <Flex vertical gap={24} className="pto-referral">
      <Breadcrumb additionalItems={breadCrumbItems} />

      <div>
        <div className="main-title" style={{ marginBottom: 8 }}>
          Referral Program
        </div>
        <div className="main-description">
          Manage referral rewards for each PTO and users in the program
        </div>
      </div>

      <Segmented<ReferralMode>
        value={mode}
        onChange={setMode}
        style={{ alignSelf: 'flex-start' }}
        options={[
          { label: 'Normal Users', value: 'normal' },
          { label: 'Partners', value: 'partner' },
        ]}
      />

      {mode === 'normal' ? <NormalUsersReferral /> : <PartnerReferral />}
    </Flex>
  )
}

export default PtoReferralProgram
